import Vue from 'vue';

/*************************************
************* DATA **************
**************************************/
var currentPage = [
	{
		"itemid":"a89h834rg",
		"headline":"Chronic Ear Infections",
		"excerpt":"Lorem ipsum excerpt goes here...",
		"image":"assets/MEEI/img/placeholder-thumb.png",
		"link":"#"
	}
]

/*************************************
************* BOOKMARKS **************
*************************************/

var globalBookmarks = [];
if (localStorage.getItem("booksmarkToShow") !== null) {
	var getBookmarks = localStorage.getItem("booksmarkToShow");
	if(getBookmarks.length > 2) {
		getBookmarks = JSON.parse(getBookmarks);
    	globalBookmarks = getBookmarks;
	}
}

var app = new Vue({
  el: ".bookmarkable-page",
  data: {
	  bookmarks: globalBookmarks,
	  bookmarkMessageAlert: "",
	  bookmarkMessage: "",
	  bookmarkMessageModal: "",
	  modalOpen: false,
	  currentPage: currentPage,
	  tempBookmark: []
  },
  methods: {
     toggleModal: function(n) {
		 var bookmarksModal = $(".bookmarks-modal");
		 var bookmarksMessage = $(".bookmarks-message");
		 $(bookmarksMessage).removeClass("open");
		 $(bookmarksModal).toggleClass("open");
		 bookmarksModalClassChangeEvent();
		 if($(bookmarksModal).hasClass("open")) {
			 this.modalOpen = true;
		 } else {
			 this.modalOpen = false;	
		 }
  	},
    toggleBookmarksMessage: function(n) {
		var bookmarksMessage = $(".bookmarks-message");
		$(bookmarksMessage).addClass("open");
 	},
    checkActive: function(n) {
		var m = this.bookmarks.some(function(person) { return checkIfExistingValue(person, "itemid", n); });
		if(m == true) {
			return true;
		}
	},
    add: function(n){
		var m = this.bookmarks.some(function(itemtocheck) { return checkIfExistingValue(itemtocheck, "itemid", n); });
		if(m == true) {
			this.deleteThis(n);
			return false;
		}
		if(this.bookmarks.length == 8) {
			this.makeSpaceInBookmarks(n);
			return false;
		}
		var thisItem = jQuery("div#" + n);
		var thisHeadline = jQuery("div#" + n).attr("data-headline");
		var thisExcerpt = jQuery("div#" + n).attr("data-excerpt");
		var thisImg = jQuery("div#" + n).attr("data-image");
		var thisLink = jQuery("div#" + n).attr("data-link");
		this.bookmarks.unshift({
			itemid: n,
			headline: thisHeadline,
			excerpt: thisExcerpt,
			image: thisImg,
			link: thisLink
		});
		var bookmarkJSON = JSON.stringify(this.bookmarks);
		localStorage.setItem("booksmarkToShow",bookmarkJSON);	
        $('html,body').animate({ scrollTop: 0 }, 'slow');
		if(this.tempBookmark.length > 0) {
			var bmkmkMsg = 'You have successfully removed this bookmark and added <span>"'+thisHeadline+'."</span>';
			this.bookmarkMessageAlert = 'You have successfully removed this bookmark and added '+thisHeadline+'.';
			this.bookmarkMessageModal = bmkmkMsg;
			this.bookmarkMessage = bmkmkMsg;
			this.tempBookmark = [];
		}  else {
			var plural = 's';
			if((8 - this.bookmarks.length) == 1) {
				plural = ''
			};
			this.bookmarkMessageAlert = 'You added a new bookmark called '+thisHeadline+'.';
			this.bookmarkMessageModal = 'You added a new bookmark called  <span>"'+thisHeadline+'."</span>';
			this.bookmarkMessage = 'You added a new bookmark called <span>"'+thisHeadline+'."</span> <a role="button">Manage Bookmarks <span class="meei-icon chevron-right-bold"></span></a>';
		}
		this.toggleBookmarksMessage();
	},
	makeSpaceInBookmarks: function(n) {
        $('html,body').animate({ scrollTop: 0 }, 'slow');
		var thisHeadline = jQuery("div#" + n).attr("data-headline");
		this.toggleModal();
		this.toggleBookmarksMessage();
		bmkmkMsg = 'You don\'t have any slots for this bookmark. Please remove an existing bookmark to save "'+thisHeadline+'.';
		this.bookmarkMessageAlert = bmkmkMsg;
		this.bookmarkMessageModal = bmkmkMsg;
		this.bookmarkMessage = 'You don\'t have any slots for this bookmark. Please remove an existing bookmark to save <span>"'+thisHeadline+'."</span>';
		this.tempBookmark = n;
	},
    deleteThis: function(n){
		this.bookmarks = jQuery.grep(this.bookmarks, function(element, index){return element.itemid === n}, true);
		var bookmarkJSON = JSON.stringify(this.bookmarks);
		localStorage.setItem("booksmarkToShow",bookmarkJSON);
        $('html,body').animate({ scrollTop: 0 }, 'slow');
		if(this.tempBookmark.length > 0) {
			var b = this.tempBookmark;
			this.add(b);
		} else {
			var plural = 's';
			if((8 - this.bookmarks.length) == 1) {
				plural = ''
			};
			var removalMsg = 'You have successfully removed this bookmark.';
			this.bookmarkMessageAlert = removalMsg;
			this.bookmarkMessageModal = removalMsg;
			this.bookmarkMessage = removalMsg;
			this.toggleBookmarksMessage();
			focusOnFirstBookmark();
		}
	},
    deleteAll: function(){
		this.bookmarks = [];
		var bookmarkJSON = JSON.stringify(this.bookmarks);
		localStorage.setItem("booksmarkToShow",bookmarkJSON);
	}
  }
});


/*************************************
************* FUNCTIONS **************
*************************************/

function checkIfExistingValue(obj, key, value) {
    return obj.hasOwnProperty(key) && obj[key] === value;
}
function bookmarksModalClassChangeEvent() {
	var bookmarksModal = $(".bookmarks-modal");
	var fontsizeToggle = $(".font-size button");
	var y = document.getElementsByClassName('page-bookmark');
	var bookmarkThisPage = y[0];
	if($(bookmarksModal).hasClass("open")) {
		$(bookmarksModal).attr("aria-hidden","false");
		focusOnFirstBookmark();
		fontsizeToggle.each(function() {
		  $(this).attr("tabindex","-1");
		});
		$(bookmarkThisPage).attr("tabindex","-1");
	} else {
		$(bookmarksModal).attr("aria-hidden","true");
		fontsizeToggle.each(function() {
		  $(this).attr("tabindex","0");
		});
		$(bookmarkThisPage).attr("tabindex","0");
		focusOnBookmarkItem();
	}
}
function focusOnBookmarkItem() {
	$("#bookmarksModalTrigger").addClass('test').focus();
}
function manageBookmarksFunc() {
	var bookmarksModal = $(".bookmarks-modal");
	var outerBookmarksMessage = $(".bookmarks-message[role='alert']");
	$(outerBookmarksMessage).removeClass("open");
	$(bookmarksModal).toggleClass("open");
	bookmarksModalClassChangeEvent();
	if($(bookmarksModal).hasClass("open")) {
		app.modalOpen = true;
	} else {
		app.modalOpen = false; 	
		focusOnBookmarkItem();
	}
}
$(document).on('click','.manage-bookmarks,.clickToOpenBookmarkModal',function() {
	manageBookmarksFunc();
});
function focusOnFirstBookmark() {
	setTimeout(function() { 
		var firstLink = $('.bookmarks-modal .bookmarks-grid').find('a:first');
		if(!firstLink.length) {
			var firstLink = $('.bookmarks-modal-close');		
		}
		$(firstLink).focus();
	}, 1000);
}
function bookmarksModalPosition() {
	var headerHeight = $('header').outerHeight(false);
	$('.bookmarks-component').css('top',headerHeight);
	if($('.emergency-alert')) {
		$('main').css('padding-top',headerHeight);		
	}
}
var windowWidth = $(window).width();
$(document).ready(function() {
	bookmarksModalPosition();
	$(window).resize(function() {
		var checkWindowWidth = $(window).width();
		if(checkWindowWidth !== windowWidth) {
			windowWidth = checkWindowWidth;
			bookmarksModalPosition();
		}
	});
    var banner_height = $("header").height() * 3;
	var openBookmarkHeight = $(".bookmarks-modal").height();
	var scrollPoint = (openBookmarkHeight > banner_height ? openBookmarkHeight : banner_height);
    var lastScrollTop = 0;
    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      var currScrollTop = $(this).scrollTop();
      if (scroll >= scrollPoint && currScrollTop > lastScrollTop) { 
		  if(!($(".bookmarks-modal").hasClass('open'))) {
		      $("header").addClass("offScreen");
			  $(".bookmarkable.page-bookmark-wrapper").css("top","-100px");		  	
		  }
      } else {
	      $("header").removeClass("offScreen");
		  bookmarksModalPosition();
      }
      lastScrollTop = currScrollTop;
    });	
});

$(document).keyup(function(e) {
  if (e.keyCode === 27) {
  	var bookmarksModal = $(".bookmarks-modal");
  	if($(bookmarksModal).hasClass("open")) {
	  manageBookmarksFunc();
    }
  } // esc
});

$("main").on("focusin",function(e) {
 	var bookmarksModal = $(".bookmarks-modal");
 	if($(bookmarksModal).hasClass("open")) {
	  manageBookmarksFunc();
    }
});